import FilterInTable from "../../../../../views/Manage/FilterInTable";
import ActionButton from "../../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton";
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable";
import StatusBadge from "../../../../common/AdminCommonComponents/StatusBadge/StatusBadge";

const Wholesale = () => {
  const actions = [
    { label: 'View Detail', action: () => console.log('view detail') },
    { label: 'Change Status', action: () => console.log('Change Status') },
    { label: 'Delete', action: () => console.log('Delete') },
  ]

  const tableData = [
    { sr: '1', productID: '#5621', sku: 'SHOE-RUN-BL-21', productName: 'Adidas Ultraboost', category: 'Footwear', sellerID: '#1234', stock: '8', price: '$25', status: 'Active' },
    { sr: '2', productID: '#5984', sku: 'TEE-SPT-WH-34', productName: 'Nike Dry-Fit T-Shirt', category: 'Apparel', sellerID: '#7890', stock: '15', price: '$18', status: 'Inactive' },
    { sr: '3', productID: '#5711', sku: 'SHOE-CAS-BK-09', productName: 'Puma Casual Shoes', category: 'Footwear', sellerID: '#5678', stock: '5', price: '$30', status: 'Active' },
    { sr: '4', productID: '#5843', sku: 'BAG-SPT-RD-22', productName: 'Reebok Gym Bag', category: 'Accessories', sellerID: '#4321', stock: '20', price: '$15', status: 'Inactive' },
    { sr: '5', productID: '#5907', sku: 'JKT-WN-BL-01', productName: 'North Face Jacket', category: 'Outerwear', sellerID: '#8765', stock: '3', price: '$50', status: 'Active' },
    { sr: '6', productID: '#5764', sku: 'CAP-SPT-WH-11', productName: 'Under Armour Cap', category: 'Accessories', sellerID: '#2345', stock: '25', price: '$10', status: 'Inactive' },
  ];

  const columns = [
    { name: 'Sr.', selector: (row) => row.sr, grow: 0.5 },
    { name: 'Product ID', selector: (row) => row.productID },
    { name: 'SKU', selector: (row) => row.sku },
    { name: 'Product Name', selector: (row) => row.productName },
    { name: 'Category', selector: (row) => row.category },
    { name: 'Seller ID', selector: (row) => row.sellerID },
    { name: 'Stock', selector: (row) => row.stock },
    { name: 'Price', selector: (row) => row.price },
    { name: 'Status', cell: (row) => <StatusBadge statusName={row.status} /> },
    { name: 'Action', cell: () => <ActionButton options={actions} /> },
  ]

  return (
    <>
      <FilterInTable componentName="Brand Management Product Overview" />
      <DynamicDatatable columns={columns} data={tableData} type="gray" pagination />
    </>
  )
};

export default Wholesale;